
export const getThumbUrlFromItem = (item) => (
    item.images &&
    item.images.length > 0 &&
    item.images[0].thumb &&
    item.images[0].thumb.length > 0 &&
    item.images[0].thumb[0].url
);

export const getParsedDataFromPages = (pages, key) => {
  const page = (Array.isArray(pages) && pages.length > 0) ? pages[0] : pages;
  if (page && page.hasOwnProperty(key)) {
    try {
      return JSON.parse(page[key]);
    } catch (error) {
      return {
        error: error.message,
      }
    }
  }
  return {};
};

export const getDataFromACF = (pages, key, defaultVar) => {
  const acf = getParsedDataFromPages(pages, 'acf');
  if (acf && acf.hasOwnProperty(key)) {
    return acf[key];
  }
  return (typeof defaultVar !== 'undefined') ? defaultVar : {};
};



// WEBPACK FOOTER //
// ./src/utils/deepProps.js